module.exports = __webpack_public_path__ + "img/globe-life.378b5dae.png";